"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M11.993 4.2 1.624 12.11c-.46.34-1.1.26-1.43-.18-.33-.44-.23-1.08.23-1.42l10.88-8.3c.29-.214.651-.261.961-.157.164.026.325.091.47.198v-.01l10.84 8.26c.46.34.56.98.23 1.42-.33.44-.97.52-1.43.18l-10.382-7.9Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M2.994 21v-8c0-.55.45-1 1-1s1 .45 1 1v7h4v-6.19a.708.708 0 0 1 .19-.474c.139-.205.339-.335.56-.335h4.5c.219 0 .417.127.555.328.123.129.193.3.195.477V20h4v-7c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1h-16c-.55 0-1-.45-1-1Zm8-6h2v5h-2v-5Z",
    clipRule: "evenodd"
  })]
});